// Utils
import { getTimestamp } from '../utils/timeUtil';
import { getGlobalClientId } from '../uid/ClientIdInstance';

// Constants
import { COMMENT_ID_PREFIX, CommentActionType } from './commentConstants';
import { MNComment } from './commentTypes';
import { CommentsAddAction, CommentLoadAction, CommentsUpdateAction, CommentsDeleteAction } from './commentActionsType';
import { TiptapContent } from '../tiptap/tiptapTypes';

export const getNewCommentId = (id: string = getGlobalClientId().getElementId()) => `${COMMENT_ID_PREFIX}${id}`;

export const commentsLoad = ({ comments }: { comments: Record<string, MNComment> }): CommentLoadAction => ({
    type: CommentActionType.COMMENTS_LOAD,
    comments,
});

export const commentsAdd = ({
    id,
    text,
    elementId,
    threadId,
    userId,
    sync = true,
    transactionId,
}: {
    id?: string;
    text: TiptapContent;
    elementId: string;
    threadId: string;
    userId: string;
    sync?: boolean;
    transactionId?: number;
}): CommentsAddAction => ({
    _id: getNewCommentId(id),
    type: CommentActionType.COMMENTS_ADD,
    createdAt: getTimestamp(),
    userId,
    elementId,
    threadId,
    text,
    transactionId,
    sync,
});

export const commentsUpdate = ({
    _id,
    elementId,
    text,
    contentUpdate,
    userId,
    sync = true,
    transactionId,
}: {
    _id: string;
    elementId: string;
    text: TiptapContent;
    userId: string;
    sync: boolean;
    contentUpdate?: {
        changes: Record<string, unknown>;
    };
    transactionId?: number;
}): CommentsUpdateAction => ({
    _id,
    elementId,
    type: CommentActionType.COMMENTS_UPDATE,
    text,
    contentUpdate,
    userId,
    transactionId,
    sync,
});

export const commentsDelete = ({
    _id,
    elementId,
    userId,
    threadId,
    sync = true,
    transactionId,
}: {
    _id: string;
    elementId: string;
    userId: string;
    threadId: string;
    sync: boolean;
    transactionId?: number;
}): CommentsDeleteAction => ({
    _id,
    elementId,
    type: CommentActionType.COMMENTS_DELETE,
    threadId,
    userId,
    transactionId,
    sync,
});
